<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>	
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="table" @Refresh="Refresh" :scrId="scrId" />					
				</sf-card>
			</div>		
		</div>
		
	</div>
</template>

<script>
import SearchContainer from './Search/SearchContainer.vue';
import TableContainer from './Table/TableContainer.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, TableContainer},
	methods: {
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.searchContainer.searchList();
		}			
	}
};
</script>

<style></style>
